const getters = {
  name: (state) => state.user.name,
  avatar: (state) => state.user.avatar,
  openid: (state) => state.user.openid,
  userid: (state) => state.user.userid,
  corp_id: (state) => state.user.corp_id,
};
export default getters;
